import api from './api';

// Soil Management Service
export const soilManagementService = {
  // Get all soil types with pagination
  getSoilTypes: async (params = {}) => {
    try {
      const response = await api.get('/soil-types', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching soil types:', error);
      throw new Error('Failed to fetch soil types');
    }
  },

  // Get soil type by ID
  getSoilTypeById: async (id) => {
    try {
      const response = await api.get(`/soil-types/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching soil type:', error);
      throw new Error('Failed to fetch soil type');
    }
  },

  // Create new soil type
  createSoilType: async (soilData) => {
    try {
      const response = await api.post('/soil-types', soilData);
      return response.data;
    } catch (error) {
      console.error('Error creating soil type:', error);
      if (error.response?.status === 403) {
        throw new Error('Access denied. Admin/Supervisor privileges required.');
      }
      throw new Error('Failed to create soil type');
    }
  },

  // Update soil type
  updateSoilType: async (id, soilData) => {
    try {
      const response = await api.put(`/soil-types/${id}`, soilData);
      return response.data;
    } catch (error) {
      console.error('Error updating soil type:', error);
      if (error.response?.status === 403) {
        throw new Error('Access denied. Admin/Supervisor privileges required.');
      }
      if (error.response?.status === 404) {
        throw new Error('Soil type not found');
      }
      throw new Error('Failed to update soil type');
    }
  },

  // Delete soil type
  deleteSoilType: async (id) => {
    try {
      const response = await api.delete(`/soil-types/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting soil type:', error);
      if (error.response?.status === 403) {
        throw new Error('Access denied. Admin privileges required.');
      }
      if (error.response?.status === 404) {
        throw new Error('Soil type not found');
      }
      throw new Error('Failed to delete soil type');
    }
  }
};
